import { combineReducers } from 'redux';
import list from './list';
import entities from './entities';

export const reducers = combineReducers({
    list,
    entities
});

export default reducers;